import type { CategoryOfCableSystem } from "./types";

// Power says nothing about which kind of power device it is, so it never decides a category.
export const categoryOfCableSystem: CategoryOfCableSystem = (system) => {
  if (system === "bma") return "fireAlarm";
  if (system === "safety") return "emergencyLighting";
  if (system === "media") return "data";
  if (system === "earthing") return "earthing";
  return null;
};
